import React from 'react';

import { Box } from '@tanium/react-box';

/**
 * Props to enable specifying a context label.
 */
export interface ContextLabelProps {
  /**
   * An optional label to provide context to the chart.
   */
  contextLabel?: string;
}

export const contextLabelRenderer = ({ contextLabel }: ContextLabelProps): JSX.Element | null => {
  return contextLabel ? <Box textAlign="center">{contextLabel}</Box> : null;
};
